import React from 'react';
import { StoryTelling2023 } from 'views/Literaryclub2023/components';

const LifeSkillPage = () => {
  return <StoryTelling2023/>;
};

export default LifeSkillPage;